import { AuthenticateParams } from 'configs/constants/enums'
import {
  GOOGLE_LINK_OPEN_ACCOUNT_SESSION_KEY,
  GOOGLE_SSO_CREDENTIAL_KEY,
  GOOGLE_SSO_INVITATION_TOKEN_KEY,
  OPEN_MY_ACCOUNT_PASSWORD_SETUP_SESSION_KEY
} from 'constants/google-sso'

/** sessionStorage — email verify bypass (subdomain guard). */
export const EMAIL_VERIFY_BYPASS_SESSION_KEY = 'emailVerifyBypass'

const SSO_LOCAL_STORAGE_KEYS = ['sso-state', 'sso-org-id', 'sso-provider', 'sso-auto-create'] as const

/** Play dashboard mock profile picker (RallyPD). */
export const PLAY_ACTIVE_PROFILE_LOCAL_KEY = 'rallypd:activePlayProfileId'

const SESSION_KEYS_TO_CLEAR_ON_LOGOUT: readonly string[] = [
  GOOGLE_SSO_CREDENTIAL_KEY,
  GOOGLE_SSO_INVITATION_TOKEN_KEY,
  OPEN_MY_ACCOUNT_PASSWORD_SETUP_SESSION_KEY,
  GOOGLE_LINK_OPEN_ACCOUNT_SESSION_KEY,
  EMAIL_VERIFY_BYPASS_SESSION_KEY
]

/**
 * Removes all client-side auth/session carry-over so the next load cannot
 * resurrect org-picker, Google SSO mid-flow, or stale tokens on this origin.
 */
export function clearAuthClientPersistence(): void {
  const localKeys = [
    ...Object.values(AuthenticateParams),
    ...SSO_LOCAL_STORAGE_KEYS,
    PLAY_ACTIVE_PROFILE_LOCAL_KEY
  ]
  for (const key of localKeys) {
    try {
      localStorage.removeItem(key)
    } catch {
      // ignore quota / private mode
    }
  }
  for (const key of SESSION_KEYS_TO_CLEAR_ON_LOGOUT) {
    try {
      sessionStorage.removeItem(key)
    } catch {
      // ignore
    }
  }
}
